// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node) => {
  const { colorName, swatch = [] } = choozy(node);

  const swatches = [].concat(swatch);

  const defaultName = colorName.textContent;

  let timeout = null;

  swatches.forEach((el) => {
    el.addEventListener('mouseenter', () => {
      clearTimeout(timeout);

      colorName.textContent = el.dataset.swatch;
    });
    el.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        colorName.textContent = defaultName;
      }, 100);
    });
  });
});
